import {
  useSegmentV1ControllerGetSegments,
  useRingV1ControllerGetRings,
  useSegmentDrawConfigV1ControllerGetByScanSite,
} from 'generated/apiComponents';
import { useSession } from 'technical/auth/client';
import { getLocalStorageValue } from 'technical/local-storage';
import { SCAN_SITE_KEY } from 'technical/local-storage/constants';
import {
  scanSiteSchema,
  type ScanSiteSchema,
} from 'technical/local-storage/types';

export const useDataFetch = ({
  enabled,
  updatedSince,
}: {
  enabled: boolean;
  updatedSince?: string;
}) => {
  const { data: session } = useSession();

  const scanSite = getLocalStorageValue<ScanSiteSchema>({
    key: SCAN_SITE_KEY,
    schema: scanSiteSchema,
  });

  const isFetchReady = enabled && !!session?.user.projectId;

  const {
    data: segments,
    isSuccess: isSegmentsSuccess,
    isFetching: isSegmentsFetching,
  } = useSegmentV1ControllerGetSegments(
    {
      queryParams: {
        projectId: session?.user.projectId ?? '',
        ...(updatedSince ? { updatedSince } : {}),
      },
    },
    {
      enabled: isFetchReady,
    },
  );
  const {
    data: rings,
    isSuccess: isRingsSuccess,
    isFetching: isRingsFetching,
  } = useRingV1ControllerGetRings(
    {
      queryParams: {
        scanSiteId: scanSite?.id ?? '',
        ...(updatedSince ? { updatedSince } : {}),
      },
    },
    {
      enabled: isFetchReady,
    },
  );
  const {
    data: segmentDrawConfig,
    isSuccess: isSegmentDrawConfigSuccess,
    isFetching: isSegmentDrawConfigFetching,
  } = useSegmentDrawConfigV1ControllerGetByScanSite(
    {
      queryParams: {
        scanSiteId: scanSite?.id ?? '',
      },
    },
    {
      enabled: enabled && !!scanSite?.id,
    },
  );

  return {
    segments,
    isSegmentsSuccess,
    isSegmentsFetching,
    rings,
    isRingsSuccess,
    isRingsFetching,
    segmentDrawConfig,
    isSegmentDrawConfigSuccess,
    isSegmentDrawConfigFetching,
  };
};
